import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AbstractService } from './abstract.service';
import { environment } from 'environments/environment';
import { UsuarioAlerta } from "app/dto/usuario-alerta.dto";
import { Page } from "app/dto/page.dto";
import { Alerta } from "app/dto/alerta.dto";

@Injectable({
  providedIn: 'root'
})
export class AlertaUsuarioService extends AbstractService<UsuarioAlerta>{
  constructor(http: HttpClient) {
    super(http, environment.url_backend + 'usuario-alerta');
  }

  private getParams(): HttpParams {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("relations", "@alerta()@usuario()");
    return httpParams;
  }

  findAllByIdUsuario(): Observable<UsuarioAlerta[]> {
    return this.http.get<UsuarioAlerta[]>(this.urlServicio + "/usuario", { params: this.getParams() });
  }

  findAllNoLeidasByIdUsuario(): Observable<UsuarioAlerta[]> {
    return this.http.get<UsuarioAlerta[]>(this.urlServicio + "/usuario/no-leidas", { params: this.getParams() });
  }

  paginado(page: number, size: number, leido: boolean, fechaPospuesto: Date, mensaje: string): Observable<Page> {
    let params = this.getParams();
    params = params.set("page", page.toString());
    params = params.set("size", size.toString());

    let dto = {} as UsuarioAlerta;
    dto.leido = leido;
    dto.fechaPospuesta = fechaPospuesto;
    dto.alerta = {} as Alerta;
    dto.alerta.mensaje = mensaje;

    return this.http.post<Page>(this.urlServicio + "/usuario/paginado", dto, { params });
  }
}
